import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';
import units from '../../../../../lib/units';

import InlineInput from '../InlineInput';
import numericInput from '../../../../../lib/numericInput';

const PrintDoubleSided = ({
  t,
  isMetric,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will print')}
        <InlineInput
          maxLength={4}
          apiKey={'input_takeaction_print_double_sided_number'}
        />
        {t('sheets double-sided instead of single-sided per week.')}
      </p>
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: t('{{value}} {{unit}} CO<sub>2</sub> per ton of paper', {
                value: numericInput.format(isMetric ? units.lbsToKg(14409) : 14409),
                unit: isMetric ? t('kgs', { ns: 'units' }) : t('lbs', { ns: 'units' }),
              }),
            }}
          />.
        </li>
        <li>
          {t('0.006 dollars per sheet of paper')}
        </li>
      </ul>
    </div>
  </div>
);

PrintDoubleSided.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('printDoubleSided'),
  connect(mapStateToProps, mapDispatchToProps)(PrintDoubleSided),
);
